import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from "./pages/Home";
import Services from "./pages/Services";
import Clients from "./pages/Clients";
import Experts from "./pages/Experts";
import SuccessStories from "./components/SuccessStoriesImage";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import SplashScreen from "./components/SplashScreen/SplashScreen";
import ExpertForm from "./pages/ExpertForm";
import DefaultLayout from "./layout/Layout";
import ScrollToTop from "./ScrollToTop";
import Cookies from "js-cookie";

const App = () => {
    // Initialize from localStorage
    const gifCookie = Cookies.get("gifPlayed");

    const needsLoading = !gifCookie ? true : false
    const [loading, setLoading] = useState(needsLoading);

    useEffect(() => {
        if (!gifCookie) {
            Cookies.set("gifPlayed", "true", { expires: 1 });
            const timer = setTimeout(() => {
                setLoading(false);
            }, 2500); // Change the timeout duration as needed

            return () => clearTimeout(timer);
        }
    }, []);




    return loading ? (
        <SplashScreen />
    ) : (
        <>
            <Router>
                <ScrollToTop />
                <div className="flex flex-col bg-white shadow-xl px-30" id="page-top">
                    <Routes>
                        <Route path="/" element={
                            <DefaultLayout>
                                <Home />
                            </DefaultLayout>
                        }
                        />
                        <Route path="/services" element={
                            <DefaultLayout>
                                <Services />
                            </DefaultLayout>
                        } />
                        <Route path="/clients" element={
                            <DefaultLayout>
                                <Clients />
                            </DefaultLayout>
                        } />
                        <Route path="/experts" element={
                            <DefaultLayout>
                                <Experts />
                            </DefaultLayout>
                        } />
                        <Route path="/expert-form" element={<ExpertForm />} />
                        <Route path="/success-stories" element={<DefaultLayout>
                            <SuccessStories />
                        </DefaultLayout>} />
                        <Route path="/about-us" element={<DefaultLayout>
                            <AboutUs />
                        </DefaultLayout>} />
                        <Route path="/contact-us" element={<DefaultLayout>
                            <ContactUs />
                        </DefaultLayout>} />
                    </Routes>
                </div>
            </Router>
            <ToastContainer />
        </>
    );
};

export default App;
